import { isRouteErrorResponse } from 'react-router-dom'
import { HTTP_STATUS } from 'ComponentLibrary/src/common/http'

export const ExhaustivenessError = (value: never): never => {
    throw new Error(`Ungültiger Wert: ${JSON.stringify(value)}`)
}

export const getStatusCode = (error: unknown): number | undefined => {
    if (isRouteErrorResponse(error)) {
        return error.status
    }
    if (error && typeof error === 'object' && 'statusCode' in error && typeof error.statusCode === 'number') {
        return error.statusCode
    }
    return undefined
}

export const getTranslatedError = (statusCode?: number) => {
    switch (statusCode) {
        case HTTP_STATUS.Unauthorized:
            return {
                errorTitle: '401 Zugriff verweigert',
                errorMessage:
                    'Ihr Zugriff wurde verweigert. Bitte versuchen Sie, sich abzumelden und erneut anzumelden oder die Seite zu aktualisieren. Falls das Problem weiterhin besteht, wenden Sie sich bitte an den Support.',
            }
        case HTTP_STATUS.Forbidden:
            return {
                errorTitle: '403 Zugriff verweigert',
                errorMessage: 'Sie haben keine Zugriffsberechtigung. Wenden Sie sich ggf. an den Support.',
            }
        case HTTP_STATUS.NotFound:
            return {
                errorTitle: '404 Seite nicht gefunden',
                errorMessage: 'Entschuldigung, hier ist wohl etwas schief gelaufen. Die gewünschte Seite kann nicht gefunden werden.',
            }
        case undefined:
        default:
            return {
                errorTitle: 'Ups...',
                errorMessage: 'Entschuldigung, ein unerwarteter Fehler ist aufgetreten.',
            }
    }
}
